import { User } from "@/models/user.model";
import { useAuthStore } from "@/store/auth";

const emptyImg: string =
  "https://video-thumb.s3.sa-east-1.amazonaws.com/65197bdbplaceholder.png";

function getTokenFromStorage() {
  if (useAuthStore.getData)
    return `Bearer ${useAuthStore.getData?.accessToken}`;
  else return "no token";
}

function getUserFromStorage(hasUser?: any): User {
  const user = useAuthStore.getData;
  if (user) {
    var arrName = user.userName?.split(" ");
    user.firstName = arrName ? arrName[0] : "";
  }
  return hasUser ?? user;
}

function storeUser(user: User): void {
  useAuthStore.setData(user);
}

function clearStorage(): void {
  useAuthStore.logout();
}

export {
  clearStorage,
  emptyImg,
  getTokenFromStorage,
  getUserFromStorage,
  storeUser
};

